async function getTerraformExport() {
  return await fetch('/terraform-exports.json').then((data) => data.json());
}

async function getAWSExports() {
  const terraformExports = await getTerraformExport();
  return {
    domain: terraformExports.VUE_APP_DOMAIN.value,
    identity_pool_id: terraformExports.VUE_APP_IDENTITY_POOL_ID.value,
    s3_bucket_prefix: terraformExports.VUE_APP_BUCKET_PREFIX.value,
    aws_project_region: terraformExports.VUE_APP_AWS_REGION.value,
    Auth: {
      region: terraformExports.VUE_APP_AWS_REGION.value,
      userPoolId: terraformExports.VUE_APP_USER_POOL_ID.value,
      userPoolWebClientId: terraformExports.VUE_APP_USER_POOL_CLIENT_ID.value
    },
    Storage: {
      AWSS3: {
        systemBucket: terraformExports.VUE_APP_SYSTEM_BUCKET.value,
        unpublishedBucket: terraformExports.VUE_APP_UNPUBLISHED_BUCKET.value,
        publishedBucket: terraformExports.VUE_APP_PUBLISHED_BUCKET.value
      }
    }
  };
}

export default getAWSExports;
